

import { useEffect, useState } from 'react';
import img from '../assets/images/background.jpg'
import { useMediaQuery } from 'react-responsive';


export const MainContent = () => {

  const isSmallScreen = useMediaQuery({ query: `(max-width: 768px)` });

    const [targetDate] = useState(new Date('2024-10-19T19:00:00'))
    const [days, setDays] = useState(0);
    const [isMarried, setIsMarried] = useState(false);

  useEffect(() => {
    const updateCountdown = () => {
        const now = new Date();
        const difference = targetDate.getTime() - now.getTime(); // Usa getTime para obter o valor em milissegundos

        let days = Math.floor(difference / (1000 * 60 * 60 * 24));

        if (difference <= 0) {
            setIsMarried(true);
            days = days * -1
        }

        setDays(days);
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);

    return () => clearInterval(timer);
}, [targetDate]);

  return (
    <section id='mainContent' className='relative'>
      <div id="overlay" className='absolute w-full h-full '></div>
      <div className='absolute top-5 md:top-1/3 right-5'>
        <p className='amatic-sc-bold text-2xl md:text-4xl' >19.10.2024 19h - {isMarried ? 'Foi a' : 'Faltam'} {days} dias</p>
      </div>
      <div className='absolute top-5 md:top-1/3 left-5'>
        <h2 className='amatic-sc-bold text-2xl md:text-4xl'>Fernanda e Leonardo</h2>
      </div>
      {isSmallScreen 
        ? <div className='h-60' style={{ backgroundImage: `url(${img})`, backgroundPosition: '50% 90%', backgroundSize: '200%', backgroundRepeat: 'no-repeat' }}></div>
        : <img src={img} alt="background" /> 
      }
    </section>
  );
};
